// ============================================================
// MiAsistenciaDiariaPage — Vista del estudiante de su asistencia
// diaria (entrada al colegio). Calendario mensual con leyenda.
// ============================================================

import React, { useState, useEffect } from 'react';
import { useAuth } from 'contexts/AuthContext';
import { matriculaService } from 'services/matriculaService';
import CalendarioAsistenciaDiaria from 'components/asistencia/CalendarioAsistenciaDiaria';

const Spinner = () => (
  <svg className="animate-spin w-8 h-8 text-blue-600" viewBox="0 0 24 24" fill="none">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4Z" />
  </svg>
);

const MiAsistenciaDiariaPage: React.FC = () => {
  const { user } = useAuth();
  const [matriculaId, setMatriculaId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    matriculaService.getByEstudiante(user.idUsuario)
      .then(m => {
        if (cancelled) return;
        if (!m) {
          setError('No se encontró una matrícula activa.');
        } else {
          setMatriculaId(m.idMatricula);
        }
      })
      .catch(err => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Error al cargar la matrícula');
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [user]);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-slate-800">Mi asistencia diaria</h2>
        <p className="text-slate-400 text-sm mt-0.5">Registro de tu entrada al colegio día a día</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Spinner /></div>
      ) : error ? (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-red-600 text-sm">{error}</div>
      ) : matriculaId ? (
        <CalendarioAsistenciaDiaria matriculaId={matriculaId} />
      ) : null}
    </div>
  );
};

export default MiAsistenciaDiariaPage;
